export default __webpack_public_path__ + "static/media/institute-11-min.2ea3948d.webp";